import React, { Component } from "react";
import Strings, { LVStrings } from "@my-dld/assets/strings";
import Popup from "@my-dld/components/Popup/Popup";
import { IJOPRequestDetails } from "./JOPRequests";
import { DetailsKV } from "../MyDLD/PropertyDetails";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import TextAreaInputField from "@eres/forms-web/TextAreaInputField";
import { DashboardSectionTitle } from "../MyDLD/Portfolio/Summary";
import Dropzone from "react-dropzone";
import DocumentInputField from "@my-dld/components/Form/DocumentInputField";
import { Docs } from "./JOPService";
import FormRow from "@eres/forms-web/FormRow";
import { OwnerCommitteeApi } from "../../ownercommitteeapi";
import { checkValidationErrorWithMessage } from "../../ownercommitteeapi/api";
import { hideLoading, LoadableDataState, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { ErrorContainer } from "@eres/forms";
import { checkNonEmpty } from "@my-dld/components/Form/FormField";
import { CloseRequest, ForwardToOCRequest, RequestTenderRequest } from "../../ownercommitteeapi/entities";
import MultiChoiceDropDown from "@my-dld/components/DropDown/MultiChoiceDropDown";
import { LocaleUtil } from "@eres/core";
import { Props as BDProps } from "@my-dld/components/DropDown/BaseDropDown";
import { JOPApi } from "./Api";

interface Props {
	workflowType: "closeRequest" | "requestTender" | "forwardToOc";
	onDismiss: () => void;
	request: IJOPRequestDetails;
	onShowSuccess?: ( referenceNumber: string ) => void;
}

enum TRANSFER_REASON {
	TECHNICAL,
	FINANCIAL,
}

interface State extends LoadableDataState {
	workFlowComments?: string;
	selectedReasons?: any[];
	attachments?: any;
}

const TRANSFER_REASONS = [ { id: 0, title: LVStrings.technical }, { id: 1, title: LVStrings.financial } ];

const MAX_SIZE = 2 * 1024 * 1000;
const MAX_PAGES = 10;

const BProps: Partial<BDProps> = {
	wrapperClass: "col-md-12",
	dropButtonClass: "btn btn-default"
};

class WorkflowPopup extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = { errorContainer: {}, loadState: "done", selectedReasons: [] };
	}

	getTitle = () => {
		switch ( this.props.workflowType ) {
			case "closeRequest":
				return Strings.close_request;
			case "forwardToOc":
				return Strings.forward_to_oc;
			case "requestTender":
				return Strings.transfer_to_rera;
		}
	};

	render() {
		const { workflowType, request } = this.props;
		const fieldProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			errorManager: defaultErrorManager,
		};
		const { errorContainer, selectedReasons } = this.state;
		return <Popup
			id={ "JOPServiceWorkflowPopup" }
			modalMainContainer={ "modal fade" }
			modalSubContainer={ "modal-dialog modal-dialog-centered modal-lg" }
			clickOutsideToDismiss={ false }
			showCloseButton={ true }
			closeClass={ "close modal-close-svg-icon" }
			closeSpanClass={ "close-svg-icon" }
			modalBodyContainer={ "modal-body" }
			showIcon={ false }
			title={ this.getTitle() }
			onDismiss={ this.dismissModel }
			footer={ <>
				<button
					type="button" className="btn btn_style1 btn_1"
					data-uw-styling-context="true" onClick={ this.onSubmit }>{ Strings.submit }</button>
				<button
					type="button" className="btn btn_style1 btn-grey"
					data-uw-styling-context="true" data-bs-dismiss="modal">{ Strings.close }</button>
			</> }>
			<div className="d-flex flex-column">
				<div className={ "flex-grid flex-order" }>
					<DetailsKV label={ Strings.request_number } value={ request.referenceNumber }/>
				</div>

				{ workflowType === "requestTender" ?
					<div className="row green-list-form greenlist-filter">
						<MultiChoiceDropDown
							showChips={ true }
							baseProps={ BProps }
							items={ TRANSFER_REASONS }
							title={ Strings.transfer_reason }
							id={ "transferReasons" }
							formatter={ i => LocaleUtil.getLocalValue( i.title ) }
							toId={ i => i.id }
							values={ selectedReasons }
							onChange={ this.onTransferReasonsChanged }/>
					</div> : null }
				<TextAreaInputField
					{ ...fieldProps }
					required={ true }
					id={ "workFlowComments" }
					label={ Strings.comments }/>
				<FormRow { ...fieldProps }>
					<div className={ "row" }>
						<DashboardSectionTitle title={ Strings.documents }/>
					</div>
					<div key={ "doc_info" } className="col-12 form-group">
						<Dropzone
							multiple={ true }
							maxSize={ MAX_SIZE }
							onDropRejected={ this.onDropRejected }
							onDrop={ ( files: File[] ) => {
								this.onDrop( files );
							} }
							accept={ [ "image/png", "image/jpeg", "application/pdf" ] }>
							{ ( { getRootProps, getInputProps } ) => (
								<DocumentInputField
									{ ...getRootProps() }
									required={ this.props.workflowType === "requestTender" ? true : false }
									dropZoneInputProps={ getInputProps() }
									label={ Strings.attached_documents }
									// isDocsAdded={ isDocsAdded }
									error={ errorContainer.attachments }
									// disabled={ ( docLookup.Docs && docLookup.Docs.length === maxPages ) }
								/>
							) }
						</Dropzone>
						<span>
		                        <small>{ Strings.tabu_upload_documents_note }</small><br/>
		                        <small>{ Strings.max_num_files + " : " + MAX_PAGES }</small>
		                    </span>
						<Docs onDelete={ this.onDelete } documents={ this.state.attachments }/>
					</div>
				</FormRow>
			</div>
		</Popup>;
	}

	private dismissModel = () => {
		if ( this.props.onDismiss ) this.props.onDismiss();
	};

	onTransferReasonsChanged = ( values: any[] ) => {
		this.setState( { selectedReasons: values } );
	};

	validateForm = () => {
		const state = this.state;
		let isValid = true;
		let errorViews: ErrorContainer = {};
		isValid = checkNonEmpty( state, "workFlowComments", errorViews ) && isValid;
		if (this.props.workflowType === "requestTender") {
			isValid = checkNonEmpty( state, "attachments", errorViews ) && isValid;
		}
		this.setState( { errorContainer: errorViews } );
		return isValid;
	};

	onSubmit = () => {
		switch ( this.props.workflowType ) {
			case "requestTender":
				this.requestTender();
				break;
			case "forwardToOc":
				this.forwardToOc();
				break;
			case "closeRequest":
				this.closeRequest();
				break;
		}
	};

	closeRequest = () => {
		if ( this.validateForm() ) {
			this.dismissModel();
			showLoading();
			this.uploadDocuments()
			.then( docs => {
				const { workFlowComments } = this.state;
				const closeRequest: CloseRequest = {
					id: this.props.request.jobServiceId,
					workflowComment: workFlowComments!,
					documents: docs?.map( doc => ( { id: doc.documentId } ) ),
				};
				JOPApi.closeRequest( this.props.request.jobServiceId, closeRequest )
				.then( r => {
					if ( r && r.validationErrorsList && r.validationErrorsList.length > 0 ) {
						showErrorMessage( OwnerCommitteeApi.getValidationError( r.validationErrorsList ) );
					} else if ( r && r.response && r.response.referenceNumber != null ) {
						this.props.onShowSuccess?.( r.response.referenceNumber );
					}
					hideLoading();
				} )
				.catch( reason => {
					hideLoading();
					showErrorMessage( reason );
				} );
			} )
			.catch( reason => {
				hideLoading();
				showErrorMessage( reason );
			} );
		}
	};

	requestTender = () => {
		if ( this.validateForm() ) {
			this.dismissModel();
			showLoading();
			this.uploadDocuments()
			.then( docs => {
				const { workFlowComments, selectedReasons } = this.state;
				const requestTender: RequestTenderRequest = {
					id: this.props.request.jobServiceId,
					workflowComment: workFlowComments!,
					documents: docs?.map( doc => ( { id: doc.documentId } ) ),
					isFinancialTender: selectedReasons?.find( r => r.id === TRANSFER_REASON.FINANCIAL ) != null,
					isTechnicalTender: selectedReasons?.find( r => r.id === TRANSFER_REASON.TECHNICAL ) != null
				};
				JOPApi.requestTender( this.props.request.jobServiceId, requestTender )
				.then( r => {
					if ( r && r.validationErrorsList && r.validationErrorsList.length > 0 ) {
						showErrorMessage( OwnerCommitteeApi.getValidationError( r.validationErrorsList ) );
					} else if ( r && r.response && r.response.referenceNumber != null ) {
						this.props.onShowSuccess?.( r.response.referenceNumber );
					}
					hideLoading();
				} )
				.catch( reason => {
					hideLoading();
					showErrorMessage( reason );
				} );
			} )
			.catch( reason => {
				hideLoading();
				showErrorMessage( reason );
			} );
		}
	};

	forwardToOc = () => {
		if ( this.validateForm() ) {
			this.dismissModel();
			showLoading();
			this.uploadDocuments()
			.then( docs => {
				const { workFlowComments } = this.state;
				const forwardRequest: ForwardToOCRequest = {
					id: this.props.request.jobServiceId,
					workflowComment: workFlowComments!,
					documents: docs?.map( doc => ( { id: doc.documentId } ) ),
				};
				JOPApi.forwardToOc( this.props.request.jobServiceId, forwardRequest )
				.then( r => {
					if ( r && r.validationErrorsList && r.validationErrorsList.length > 0 ) {
						showErrorMessage( OwnerCommitteeApi.getValidationError( r.validationErrorsList ) );
					} else if ( r && r.response && r.response.referenceNumber != null ) {
						this.props.onShowSuccess?.( r.response.referenceNumber );
					}
					hideLoading();
				} )
				.catch( reason => {
					hideLoading();
					showErrorMessage( reason );
				} );
			} )
			.catch( reason => {
				hideLoading();
				showErrorMessage( reason );
			} );
		}
	};

	onDropRejected = () => {
		this.setState( { errorContainer: { ...this.state.errorContainer, attachments: Strings.tabu_file_exceed_size } } );
	};

	private onDrop = ( files: File[] ) => {
		const docs = this.state.attachments;
		if ( MAX_PAGES > 1 ) {
			if ( docs && docs.length > 1 ) {
				let maxAllowed = ( MAX_PAGES - docs.length );
				if ( files.length > maxAllowed ) files = files.splice( 0, maxAllowed );
			} else if ( files.length > MAX_PAGES ) {
				files = files.splice( 0, MAX_PAGES );
			}
		}
		files.filter( x => x.type.startsWith( "image/" ) || x.type.startsWith( "application/pdf" ) )
		.forEach( file => this.addFile( file ) );
	};

	private addFile( file: File ) {
		const reader = new FileReader();
		reader.onload = () => {
			let d = this.state.attachments ? [ ...this.state.attachments ] : [];
			const binaryStr = reader.result;
			if ( d == null ) d = [];
			const newDoc = {
				Type: file.type,
				LocalData: binaryStr as string,
				FileName: file.name,
				localFile: file,
			};
			if ( MAX_PAGES > 1 ) {
				d.push( newDoc );
			} else {
				d = [ newDoc ];
			}
			let error = this.state.errorContainer;
			delete error.attachments;
			this.setState( {
				attachments: d,
				errorContainer: error,
			} );
		};
		reader.readAsDataURL( file );
	}

	onDelete = ( index: number ) => {
		const { attachments } = this.state;

		const d = attachments?.filter( ( _: any, i: number ) => i !== index );
		this.setState( {
			attachments: d,
		} );
	};

	uploadDocuments = () => {
		let uploadTasks: Promise<any>[] = [];
		const docs = this.state.attachments;
		docs?.map( ( doc: any ) => {
			if ( doc.documentId == null ) {
				uploadTasks.push( JOPApi.uploadJOPDocument( doc.localFile ).then( ( response ) => {
					return checkValidationErrorWithMessage( response );
				} ).then( response => {
					if ( response.responseCode === "Success" && response.response ) {
						doc.documentId = response.response.id;
						return Promise.resolve( doc );
					}
					return Promise.resolve( doc );
				} ).catch( reason => {
					return Promise.reject( reason.toString() );
				} ) );
			} else {
				uploadTasks.push( Promise.resolve( doc ) );
			}
		} );

		return Promise.all( uploadTasks );
	};
}

export default WorkflowPopup;
